import reducer from "./reducer";
export { default as generalSettings } from "./components/index";
export { default as generalSettingsReducerName } from "./constants";
export default reducer;
